var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
import { HeadingRegularVariants, processColorMode, ArtDirectedImage, ImageVariants } from "../../index";
export var PromotionalCardEnum;
(function (PromotionalCardEnum) {
    PromotionalCardEnum["dark"] = "dark";
    PromotionalCardEnum["light"] = "light";
})(PromotionalCardEnum || (PromotionalCardEnum = {}));
export const PromotionalCard = (_a) => {
    var { title, section, ratio = ImageVariants.ratio_3x4, mode = "light", imageUrl, imageNode, imageAlt, hasGradientOverlay = true, objectPositionLeft = "center", objectPositionTop = "center", children } = _a, props = __rest(_a, ["title", "section", "ratio", "mode", "imageUrl", "imageNode", "imageAlt", "hasGradientOverlay", "objectPositionLeft", "objectPositionTop", "children"]);
    return (_jsx(Box, { sx: Object.assign({ variant: `images.${ratio}` }, processColorMode(mode)), children: _jsxs(Box, { sx: {
                variant: `images.${ratio}`,
                position: "absolute",
                width: "100%"
            }, children: [_jsx(ArtDirectedImage, { imageUrl: imageUrl, imageNode: imageNode, imageAlt: imageAlt, objectPositionLeft: objectPositionLeft, objectPositionTop: objectPositionTop, hasGradientOverlay: hasGradientOverlay }), _jsxs(Box, { sx: {
                        position: "absolute",
                        height: "100%",
                        py: [32, 32, 32, 48],
                        px: [24, 24, 32],
                        width: "100%",
                        maxWidth: "40ch"
                    }, children: [section && (_jsx("h6", { className: "color-mode-title", sx: {
                                variant: `text.${HeadingRegularVariants.sixth}`
                            }, children: section })), title && (_jsx("h2", { className: "color-mode-title", sx: { variant: `text.${HeadingRegularVariants.second}`, mt: 4 }, children: title })), _jsx(Box, { className: "color-mode-title", sx: {
                                position: "absolute",
                                bottom: [32, null, null, 48],
                                "> * ": {
                                    mr: 16
                                }
                            }, children: children })] })] }) }));
};
//# sourceMappingURL=PromotionalCard.js.map